import React, { useEffect, useMemo } from 'react'
import { format } from 'date-fns'
import { useDispatch, useSelector } from 'react-redux'

import UploadGamAdCreative from '../../../../forms/GAM/UploadGamAdCreative'
import PageSectionHeader from '../../../../features/components/PageSectionHeader'
import GamCampaignsSection from './GamCampaignsSection'
import DateRangeWithStaticList from '../../../../features/components/DateRange/DateRangeWithStaticList'
import InventoryBreakdownAndRequiredCreatives from './InventoryBreakdownAndRequiredCreatives'

import { clearCampaigns, getCampaigns, setCampaignsDateRange } from '../../../../modules/actions/campaigns'
import { campaignsDateRangeSelector, campaignsSelector } from '../../../../modules/selectors/campaigns'
import { rightSelector } from '../../../../modules/selectors/rights'
import { selfAccountSelector } from '../../../../modules/selectors/selfAccounts'

import { GOOGLE_AD_MANAGER_PROVIDER_PLATFORM } from '../../../../constants/selectLists/platformList'
import { DATES_FORMAT_BE } from '../../../../constants/dates'
import { GAM_NETWORK_CODE } from '../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'

import useStyles from './styles'

const OnsiteGamContent = () => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const campaignsDateRange = useSelector(campaignsDateRangeSelector)

  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const { campaigns: rightCampaignsToLoad } = useSelector(rightSelector)
  const campaigns = useSelector(campaignsSelector)

  const { startDate, endDate } = campaignsDateRange

  const rightCampaignsToLoadIds = useMemo(() => {
    return rightCampaignsToLoad?.map(campaign => campaign.external_id)
  }, [rightCampaignsToLoad])

  const hasNotFetchedCampaigns = useMemo(() => {
    // This variable is used to define if there the right has campaigns to fetch
    // if we fetch campaigns with empty ids, the API will return all campaigns from the network code (what is wrong)
    if (!rightCampaignsToLoadIds?.length) {
      return false
    } else {
      const campaignsIds = campaigns.map(campaign => campaign.id)

      return rightCampaignsToLoadIds.some(id => !campaignsIds.includes(id))
    }
  }, [rightCampaignsToLoadIds, campaigns])

  useEffect(() => {
    if (hasNotFetchedCampaigns) {
      dispatch(
        getCampaigns(
          {
            date_start: startDate && format(startDate, DATES_FORMAT_BE),
            date_stop: endDate && format(endDate, DATES_FORMAT_BE),
            network_code: gamNetworkCode,
            id: rightCampaignsToLoadIds.join(',')
          },
          GOOGLE_AD_MANAGER_PROVIDER_PLATFORM
        )
      )
    }
  }, [dispatch, gamNetworkCode, startDate, endDate, hasNotFetchedCampaigns, rightCampaignsToLoadIds])

  useEffect(() => {
    return () => {
      dispatch(clearCampaigns())
    }
  }, [dispatch])

  return (
    <div className={classes.gamContent}>
      <UploadGamAdCreative
        hasNotFetchedCampaigns={hasNotFetchedCampaigns}
        rightCampaignsToLoadIds={rightCampaignsToLoadIds}
      />
      <PageSectionHeader
        title="List of Campaigns"
        RightPanel={
          <>
            <InventoryBreakdownAndRequiredCreatives rightCampaignsToLoadIds={rightCampaignsToLoadIds} />
            <DateRangeWithStaticList
              setDateRangeAction={setCampaignsDateRange}
              dateRangeSelector={campaignsDateRangeSelector}
            />
          </>
        }
      />
      <GamCampaignsSection hasNotFetchedCampaigns={hasNotFetchedCampaigns} />
    </div>
  )
}

export default OnsiteGamContent
